export var SDK_VERSION = '6.18.0';
//# sourceMappingURL=version.js.map